import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
} from '@angular/core';
import {
  QueryParamsHandling,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { RouterLinkPipe } from '../../pipes/router-link.pipe';
import { Route } from '../../enums/route';
import { Nillable, strictType } from '@web/utils';
import { RouterLinkParams } from '../../types/router-link-params';
import { RouterLinkLinkContentComponent } from '../router-link-link-content/router-link-link-content.component';
import { RouterLinkContentVariant } from '../../types/router-link-content-variant';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLinkQueryParams } from '../../types/router-link-query-params';

@Component({
  selector: 'app-router-link',
  imports: [
    RouterLink,
    RouterLinkPipe,
    RouterLinkActive,
    RouterLinkLinkContentComponent,
    NgTemplateOutlet,
  ],
  templateUrl: './router-link.component.html',
  styleUrl: './router-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouterLinkComponent {
  public readonly contents = input<boolean>(false);
  public readonly route = input.required<Route>();
  public readonly fragment = input<string>();
  public readonly queryParams = input<Nillable<RouterLinkQueryParams>>(null);
  public readonly params = input<Nillable<RouterLinkParams>>(null);
  /* prettier-ignore */
  public readonly queryParamsHandling = input<Nillable<QueryParamsHandling>>(null);
  public readonly variant = input<RouterLinkContentVariant>('default');
  public readonly activeClass = input<string>('active');

  protected readonly strictType = strictType<RouterLinkContentVariant>;

  @HostBinding('class.contents')
  public contentsClass(): boolean {
    return this.contents();
  }
}
